import { useDispatch, useSelector } from "react-redux";
import Company from "../models/company";
import {
  setAdditionalFields,
  setAdditionalFieldsLoading,
} from "../redux/company-additional-fields/company-additional-fields-slice";
import { getItem } from "../api/generics";
import { SUCCESS } from "../utils/constants/tags";
import { useEffect } from "react";
import { RootState } from "../store";
import CompanyAdditionalFields from "../models/company-additional-fields";

interface AdditionalFieldsProviderProps {
  children: React.ReactNode;
}

const AdditionalFieldsProvider: React.FunctionComponent<
  AdditionalFieldsProviderProps
> = (props) => {
  const company = useSelector((state: RootState) => state.company.data.company);

  const dispatch = useDispatch();
  const loadCompanyAdditionalFields = async (company: Company) => {
    if (company.id === undefined) {
      return;
    }
    dispatch(setAdditionalFieldsLoading(true));

    const res = await getItem<CompanyAdditionalFields>(
      `/company_additional_fields/${company.id}/`
    );

    if (res.status !== SUCCESS || res.data === undefined) {
      dispatch(setAdditionalFields(null));
      dispatch(setAdditionalFieldsLoading(false));
      return;
    }

    dispatch(setAdditionalFields(res.data));
    dispatch(setAdditionalFieldsLoading(false));
  };

  useEffect(
    () => {
      loadCompanyAdditionalFields(company);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [company]
  );

  return <>{props.children}</>;
};

export default AdditionalFieldsProvider;
